import { apiUrls } from 'consts'
import { useEffect } from 'react'
import loadRecord from './../utils/loadRecord'

interface useInitProps {
  id: string | undefined
  setUser: Function
  setDataLoaded: Function
  setShowOverlay: Function
  navigate: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    if (props.id !== undefined) {
      loadRecord(apiUrls.users, props.id).then((data) => {
        props.setUser(data)

        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    } else {
      props.navigate('/')
    }
  }, [])
}

export default useInit
